// Module
var code = `<main class="page-content flex min-h-screen flex-col p-6">
  <!-- Logo band. UIAcmeLogoView mounts here. -->
  <div
    data-region="logo"
    class="flex h-20 shrink-0 items-end rounded-lg bg-blue-500 p-4 md:h-52"
  ></div>

  <div class="mt-4 flex grow flex-col gap-4 md:flex-row">
    <!-- Copy + login CTA -->
    <div
      data-region="main"
      class="flex flex-col justify-center gap-6 rounded-lg bg-gray-50 px-6 py-10 md:w-2/5 md:px-20"
    ></div>

    <!-- Screenshot -->
    <div
      data-region="hero"
      class="flex items-center justify-center p-6 md:w-3/5 md:px-28 md:py-12"
    ></div>
  </div>
</main>
`;
// Exports
module.exports = code;